<div class="salesman-kpis">
	<div class="skp-wrap" [ngStyle]="themeVars">
		<div class="skp-icon-badge">
			<i class="material-icons">insights</i>
		</div>
		<div class="skp-header">
			<div class="skp-title-group">
				<span class="skp-title">Sales Performance</span>
				<span class="skp-subtitle" *ngIf="kpis?.period">
					{{ kpis.period.current_start | date:'MMM d' }} &ndash; {{ kpis.period.current_end | date:'MMM d' }}
					vs {{ kpis.period.previous_start | date:'MMM d' }} &ndash; {{ kpis.period.previous_end | date:'MMM d' }}
				</span>
			</div>
			<div class="skp-actions">
				<button
					type="button"
					class="skp-icon-btn"
					(click)="reload()"
					[disabled]="loading"
					matTooltip="Refresh"
					[matTooltipPosition]="'below'">
					<i class="material-icons">refresh</i>
				</button>
			</div>
		</div>

		<div class="salesman-kpis__toolbar">
			<label class="salesman-kpis__month-field">
				<span>Primary month</span>
				<input type="month" name="kpiPrimaryYm" [(ngModel)]="kpiPrimaryYm" [disabled]="loading" />
			</label>
			<label class="salesman-kpis__month-field">
				<span>Compare to</span>
				<input type="month" name="kpiCompareYm" [(ngModel)]="kpiCompareYm" [disabled]="loading" />
			</label>
			<button type="button" class="salesman-kpis__months-btn" (click)="applyCustomMonths()" [disabled]="loading || !kpiPrimaryYm || !kpiCompareYm">Apply months</button>
			<button type="button" class="salesman-kpis__months-btn salesman-kpis__months-btn--quiet" (click)="resetToRollingMtd()" [disabled]="loading" matTooltip="This month vs same span last month" [matTooltipPosition]="'below'">Rolling MTD</button>
		</div>

		<div class="salesman-kpis__body">
			<div class="kpi-loading" *ngIf="loading">
				<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>

			<div class="kpi-grid" *ngIf="!loading && kpis">
				<ng-container *ngFor="let tile of tiles">
					<ng-container *ngIf="getTile(tile) as data">
						<div class="kpi-tile" [ngClass]="'kpi-tile--' + tile.key">
							<span class="kpi-tile__stripe"></span>
							<div class="kpi-tile__header">
								<span class="kpi-tile__label">
									<i class="material-icons">{{ tile.icon }}</i>
									<span>{{ tile.label }}</span>
								</span>
								<span class="kpi-tile__chip" [ngClass]="chipClass(data.primary)">
									<i class="fa" [ngClass]="trendIcon(data.primary)"></i>
									<span>{{ trendLabel(data.primary) }}</span>
								</span>
							</div>
							<div class="kpi-tile__body">
								<div class="kpi-tile__value">
									<ng-container [ngSwitch]="data.primary.format">
										<ng-container *ngSwitchCase="'currency'">{{ data.primary.current | currency }}</ng-container>
										<ng-container *ngSwitchCase="'number'">{{ data.primary.current | number:'1.0-0' }}</ng-container>
									</ng-container>
									<span class="kpi-tile__denominator" *ngIf="data.denominator !== undefined && data.denominator !== null">
										<span class="kpi-tile__denominator-sep">/</span>{{ data.denominator | number:'1.0-0' }}
									</span>
								</div>

								<div class="kpi-tile__secondary" *ngIf="data.secondary as sec">
									<span class="kpi-tile__secondary-value">
										<ng-container [ngSwitch]="sec.value.format">
											<ng-container *ngSwitchCase="'currency'">{{ sec.value.current | currency }}</ng-container>
											<ng-container *ngSwitchCase="'number'">{{ sec.value.current | number:'1.0-0' }}</ng-container>
										</ng-container>
									</span>
									<span class="kpi-tile__secondary-label">{{ sec.label }}</span>
								</div>

								<div class="kpi-tile__prev">
									<span>
										Prev:
										<ng-container [ngSwitch]="data.primary.format">
											<ng-container *ngSwitchCase="'currency'">{{ data.primary.previous | currency }}</ng-container>
											<ng-container *ngSwitchCase="'number'">{{ data.primary.previous | number:'1.0-0' }}</ng-container>
										</ng-container>
										<ng-container *ngIf="data.secondary as sec">
											&middot;
											<ng-container [ngSwitch]="sec.value.format">
												<ng-container *ngSwitchCase="'currency'">{{ sec.value.previous | currency }}</ng-container>
												<ng-container *ngSwitchCase="'number'">{{ sec.value.previous | number:'1.0-0' }}</ng-container>
											</ng-container>
										</ng-container>
									</span>
									<span class="kpi-tile__delta" [ngClass]="chipClass(data.primary)">
										<ng-container *ngIf="data.primary.delta > 0">+</ng-container>
										<ng-container [ngSwitch]="data.primary.format">
											<ng-container *ngSwitchCase="'currency'">{{ data.primary.delta | currency }}</ng-container>
											<ng-container *ngSwitchCase="'number'">{{ data.primary.delta | number:'1.0-0' }}</ng-container>
										</ng-container>
									</span>
								</div>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>

			<div class="kpi-empty" *ngIf="!loading && !kpis">
				<p class="text-muted text-center m-0">No data available.</p>
			</div>
		</div>
	</div>
</div>
